export const $themeBlue="#5E72E4";
export const $themeButton='linear-gradient(310deg,#2dce89,#2dcecc)';